require('./bootstrap');
import '../../lib/Genie/Gallery/resources/js/import';
import '../../lib/Genie/DomElements/resources/js/import';
